import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { createAppRouter } from '#admin/router.tsx'
// A stylesheet has no export. This is how Vite is told to bundle it, and the app has no
// styling at all without it.
// oxlint-disable-next-line import/no-unassigned-import
import './styles/globals.css'

/**
 * The browser entry.
 *
 * Note what is **not** here: any theming. The tenant's palette arrived through the
 * `<link rel="stylesheet">` in `index.html` before this module was even fetched, which is the
 * point — applying tokens from JavaScript at this moment would mean the first paint had
 * already happened in the platform's default brand.
 */
const router = createAppRouter()
const container = document.querySelector('#root')

if (container === null) throw new Error('No #root element to mount into.')

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={router.options.context.queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
